import { FC, useRef, useEffect, useState } from 'react'
import { Typography, useMediaQuery } from '@mui/material'

import { TrendViewWrapper, ChartWrapper, EmptyStateWrapper } from './trendView.styles'
import OverallPerformanceChart from './OverallPerformanceChart'

export interface HistoryDataPoint {
  xValue: string
  yValue: number
}

interface Props {
  historyData: HistoryDataPoint[]
  loading: boolean
  containerRef: any
}

const TrendView: FC<Props> = ({ historyData, loading, containerRef }) => {
  const svgRef = useRef<SVGSVGElement | null>(null)
  const margin = { top: 0, right: 0, bottom: 0, left: 0 }
  const thirdBreakpoint = useMediaQuery('(min-width:1440px)')
  const [width, setWidth] = useState(thirdBreakpoint ? 215 : 186)
  const height = 132

  useEffect(() => {
    if (!containerRef.current) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newWidth = entry.contentRect.width
        setWidth(newWidth - 32) // padding if any
      }
    })

    resizeObserver.observe(containerRef.current)

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  if (loading) {
    return (
      <TrendViewWrapper>
        <ChartWrapper>
          <Typography>Loading...</Typography>
        </ChartWrapper>
      </TrendViewWrapper>
    )
  }
  if (historyData.length < 2) {
    return (
      <TrendViewWrapper>
        <EmptyStateWrapper>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.75 3V14.25C3.75 15.4926 4.75736 16.5 6 16.5H8.25M3.75 3H2.25M3.75 3H20.25M20.25 3H21.75M20.25 3V14.25C20.25 15.4926 19.2426 16.5 18 16.5H15.75M8.25 16.5H15.75M8.25 16.5L7.25 19.5M15.75 16.5L16.75 19.5M16.75 19.5L17.25 21M16.75 19.5H7.25M7.25 19.5L6.75 21M9 11.25V12.75M12 9V12.75M15 6.75V12.75"
              stroke="#A88CA4"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Typography className="title">Chart Coming Soon</Typography>
          <Typography className="description">
            We're currently gathering data for this chart. This may take a couple of weeks
          </Typography>
        </EmptyStateWrapper>
      </TrendViewWrapper>
    )
  }
  return (
    <TrendViewWrapper ref={containerRef}>
      <Typography className="overall-performance-trend-chart-title">
        {historyData[historyData.length - 1].yValue}%
      </Typography>
      <ChartWrapper>
        <OverallPerformanceChart
          ref={{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            containerRef,
            svgRef
          }}
          data={historyData}
          margin={margin}
          width={width}
          height={height}
        />
      </ChartWrapper>
    </TrendViewWrapper>
  )
}

export default TrendView
